import { Timestamp } from "firebase/firestore";
import { getFunctions, httpsCallable } from 'firebase/functions';

async function getServerTimestamp() {
  try {
    const functions = getFunctions();
    const getServerTimestamp = httpsCallable(functions, 'getServerTimestamp');
    const { data } = await getServerTimestamp();
    const serverTimestamp = data.timestamp;
    return Timestamp.fromDate(new Date(serverTimestamp));
  } catch (error) {
    console.error('Failed to fetch server timestamp:', error);
    return Timestamp.fromDate(new Date());
  }
}

export default getServerTimestamp;